import { useEffect } from 'react';
import { isTokenExpired, getToken } from './auth';

const UMA_HORA = 60 * 60 * 1000; // 3_600_000 ms

export function useTokenWatcher(onExpire, intervalMs = UMA_HORA) {
  useEffect(() => {
    const check = () => {
      if (getToken() && isTokenExpired()) {
        onExpire();
      }
    };

    check();
    const id = setInterval(check, intervalMs);
    return () => clearInterval(id);
  }, [onExpire, intervalMs]);
}